export enum TrainingStatus {
    COMPLETED = 'completed',
    INCOMPLETED = 'incompleted',
    SKIPPED = 'skipped'
  }